import request from '../untils/request';

export const kaGradeTabListApi = params => {
  return request({
    url: '/shop/ka/ka-grade-tab',
    params,
  });
};

export const kaGradeBuyersListApi = params => {
  return request({
    url: '/shop/ka/ka-grade-index',
    params,
  });
};

export const kaGradeAchievementTotalApi = params => {
  return request({
    url: '/shop/ka/ka-grade-achievement-total',
    params,
  });
};

export const kaLogsApi = params => {
  return request({
    url: '/shop/ka/ka-log',
    params,
  });
};

export const kaGetConfigApi = params => {
  return request({
    url: '/shop/ka/get-ka-config',
    params,
  });
};

export const kaSetConfigApi = params => {
  return request({
    url: '/shop/ka/set-ka-config',
    params,
  });
};

export const kaRewardRecordApi = params => {
  return request({
    url: '/shop/ka/ka-record',
    params,
  });
};

export const kaDetailsApi = params => {
  return request({
    url: '/shop/ka/achievement-list',
    params,
  });
};

export const kaDetailAchievementApi = params => {
  return request({
    url: '/shop/ka/achievement-total',
    params,
  });
};

export const kaManifesttApi = params => {
  return request({
    url: '/shop/ka/ka-annual-bonus-list',
    params,
  });
};

export const kaPreManifesttApi = params => {
  return request({
    url: '/shop/ka/ka-annual-bonus-pre-list',
    params,
  });
};

export const checkAnnualExport = params => {
  return request({
    url: '/shop/ka/export-annual-list',
    params,
  });
};

export const confirmListApi = params => {
  return request({
    url: '/shop/ka/confirm-list',
    params,
  });
};

export const payBonusApi = params => {
  return request({
    url: '/shop/ka/pay-bonus',
    params,
  });
};

export const sendSmsApi = params => {
  return request({
    url: '/shop/ka/send-sms',
    params,
  });
};

export const transToOfficialApi = params => {
  return request({
    url: '/shop/ka/trans-to-official',
    params,
  });
};
